import {
	AfterViewInit,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output
} from '@angular/core';
import { InvoicesDataProvider } from '../../../../../../shared/services/invoice/invoices-data-service/invoices.data.service';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';
import { PaymentsServiceProvider } from '../../../../../../shared/services/payments/payments-service/payments.service';
import { Invoice } from '../../invoice.model';
import { IntegrationsDataProvider } from '../../../../../../shared/services/integrations/integrations.data.service';
import { MessageService } from '../../../../../../shared/services/helpers/message-service/message.service';
import { Integrations } from '../../../../../../shared/models/models';
import { Location } from '@angular/common';
import { FileDownloadDataServiceProvider } from '../../../../../../shared/services/files/file-download-service/file-download.data.service';

@Component({
	selector: 'invoice-payment-action-buttons',
	template: require('./invoice-payment-action-buttons.html'),
	styles: [require('./invoice-payment-action-buttons.scss')]
})
export class InvoicePaymentActionButtons implements OnInit, AfterViewInit {
	@Input('data') data: Invoice;
	@Output() getInvoiceUpdated: EventEmitter<Invoice> = new EventEmitter();
	@Output() sendInvoiceEmitter: EventEmitter<any> = new EventEmitter();

	previewUrl: string;
	editUrl: string;
	isFullyPaid: boolean;
	xeroEnabled: boolean;
	qbEnabled: boolean;
	isDeleteModalOpen: boolean;

	private unsubscribe: Subject<any> = new Subject();

	constructor(
		private invoicesDataService: InvoicesDataProvider,
		private paymentsService: PaymentsServiceProvider,
		private integrationsDataService: IntegrationsDataProvider,
		private messageService: MessageService,
		private location: Location
	) {}

	ngOnInit(): void {
		this.loadPreviewUrl();
		this.getIntegrationStatus();
	}

	ngAfterViewInit(): void {
		this.prepareEditLink();
	}

	updateInvoice(invoice: Invoice): void {
		this.getInvoiceUpdated.emit(invoice);
	}

	sendInvoice(invoice: Invoice): void {
		this.sendInvoiceEmitter.emit({ isReceipt: false, data: invoice });
	}

	showDeleteModal(): void {
		this.isDeleteModalOpen = true;
		$('#deleteModal').modal();
	}

	successDeleteInvoiceModal(state): void {
		if (state) {
			this.isDeleteModalOpen = false;
			this.location.go('/payments');
		}
	}

	private loadPreviewUrl(): void {
		this.invoicesDataService
			.getInvoicePreviewURL(this.data.id)
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(data => {
				this.previewUrl = `/clients/invoice/pay/${data.link}/${this.data.id}`;
			});
	}

	private prepareEditLink(): void {
		this.data.job.inLead
			? (this.editUrl = `/leads/${this.data.job.leadId}/invoice/${
					this.data.id
			  }/update`)
			: (this.editUrl = `/jobs/${this.data.job.id}/invoice/${
					this.data.id
			  }/update`);
	}

	private getIntegrationStatus(): void {
		this.integrationsDataService
			.getIntegrationOrganization()
			.subscribe(
				data => this.successGetIntegrationStatus(data),
				err => this.messageService.showDefaultErrorMessage(err)
			);
	}

	private successGetIntegrationStatus(data: Integrations): void {
		if (data.integration && data.integration === 'XERO') {
			this.xeroEnabled = true;
			this.qbEnabled = false;
		} else if (data.integration && data.integration === 'QUICKBOOKS') {
			this.qbEnabled = true;
			this.xeroEnabled = false;
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/invoices/invoice-view/invoice-payments-action-buttons/invoice-payment-action-buttons.ts